var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 201,
    viewBox: "0 0 161 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.636 179.65V178.098H19.028V168.93H17.3V179.65H25.636ZM30.8171 179.81C33.4731 179.81 35.2491 178.13 35.2491 175.682C35.2491 173.202 33.4731 171.538 30.8171 171.538C28.1771 171.538 26.4011 173.202 26.4011 175.682C26.4011 178.13 28.1771 179.81 30.8171 179.81ZM30.8171 178.274C28.8971 178.274 28.0971 177.362 28.0971 175.682C28.0971 173.986 28.8971 173.058 30.8171 173.058C32.7531 173.058 33.5531 173.986 33.5531 175.682C33.5531 177.362 32.7531 178.274 30.8171 178.274ZM38.8391 179.81C40.6471 179.81 41.9111 179.01 42.3271 177.666H42.4391V179.65H44.0231V174.818C44.0231 172.914 42.8871 171.538 40.3591 171.538C37.8311 171.538 36.3271 172.898 36.3271 174.706V174.77H38.0391V174.706C38.0391 173.538 38.7591 173.058 40.2311 173.058C41.7511 173.058 42.3271 173.522 42.3271 174.834V175.298L38.7111 175.682C37.1431 175.858 36.1511 176.498 36.1511 177.73C36.1511 179.042 37.1911 179.81 38.8391 179.81ZM37.8791 177.618C37.8791 176.994 38.3111 176.786 39.2071 176.674L42.3271 176.322C42.3271 177.89 41.1111 178.562 39.3031 178.562C38.3111 178.562 37.8791 178.258 37.8791 177.618ZM47.2936 179.65V175.714C47.2936 173.986 48.0776 173.09 49.8216 173.09C51.4696 173.09 52.1416 173.842 52.1416 175.33V179.65H53.8696V174.866C53.8696 173.026 52.7816 171.538 50.5736 171.538C48.5576 171.538 47.5016 172.818 47.2616 174.162H47.1496V171.698H45.5656V179.65H47.2936ZM59.1694 179.81C61.4094 179.81 62.8814 178.93 62.8814 177.442C62.8814 176.13 62.0174 175.49 60.1294 175.25L58.2894 174.994C57.0894 174.834 56.7694 174.61 56.7694 173.986C56.7694 173.234 57.2814 172.914 58.7374 172.914C60.4974 172.914 60.9774 173.41 60.9774 174.354V174.45H62.6894V174.402C62.6894 172.514 61.2174 171.538 58.7854 171.538C56.3374 171.538 55.0734 172.53 55.0734 173.922C55.0734 175.25 55.9854 175.89 57.4894 176.082L59.6654 176.37C60.8014 176.53 61.1854 176.738 61.1854 177.394C61.1854 178.098 60.7214 178.418 59.1694 178.418C57.5054 178.418 56.8814 178.082 56.8814 177.042V176.914H55.1534V176.962C55.1534 178.802 56.6094 179.81 59.1694 179.81Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.8237,
    y1: 131.118,
    x2: 28.8237,
    y2: -10.3968,
    stroke: "url(#paint0_linear_51_1917)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.8237,
    y1: 131.118,
    x2: 64.8237,
    y2: -10.3968,
    stroke: "url(#paint1_linear_51_1917)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.824,
    y1: 131.118,
    x2: 100.824,
    y2: -10.3968,
    stroke: "url(#paint2_linear_51_1917)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.824,
    y1: 131.118,
    x2: 135.824,
    y2: -10.3968,
    stroke: "url(#paint3_linear_51_1917)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 29.9795,
    x2: 198.245,
    y2: 29.9795,
    stroke: "url(#paint4_linear_51_1917)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 88.9795,
    x2: 198.245,
    y2: 88.9795,
    stroke: "url(#paint5_linear_51_1917)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 58.9795,
    x2: 198.245,
    y2: 58.9795,
    stroke: "url(#paint6_linear_51_1917)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1917)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_51_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0578 44.1851C48.1149 44.1851 47.2107 44.5596 46.544 45.2263C45.8772 45.8931 45.5027 46.7973 45.5027 47.7402C45.5027 48.6831 45.8772 49.5873 46.544 50.2541C47.2107 50.9208 48.1149 51.2953 49.0578 51.2953C50.0007 51.2953 50.905 50.9208 51.5717 50.2541C52.2384 49.5873 52.613 48.6831 52.613 47.7402C52.613 46.7973 52.2384 45.8931 51.5717 45.2263C50.905 44.5596 50.0007 44.1851 49.0578 44.1851Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4673 40.0373C32.4673 38.4004 33.7945 37.0747 35.4299 37.0747H62.686C64.3214 37.0747 65.6486 38.402 65.6486 40.0373V55.4429C65.6486 57.0799 64.3214 58.4056 62.686 58.4056H35.4299C35.0408 58.4056 34.6556 58.3289 34.2962 58.1801C33.9367 58.0312 33.6101 57.8129 33.335 57.5378C33.0599 57.2627 32.8417 56.9361 32.6928 56.5767C32.5439 56.2173 32.4673 55.832 32.4673 55.4429V40.0373ZM43.1327 47.7401C43.1327 46.1687 43.757 44.6616 44.8682 43.5504C45.9794 42.4392 47.4865 41.8149 49.058 41.8149C50.6294 41.8149 52.1365 42.4392 53.2477 43.5504C54.3589 44.6616 54.9832 46.1687 54.9832 47.7401C54.9832 49.3116 54.3589 50.8187 53.2477 51.9299C52.1365 53.0411 50.6294 53.6654 49.058 53.6654C47.4865 53.6654 45.9794 53.0411 44.8682 51.9299C43.757 50.8187 43.1327 49.3116 43.1327 47.7401ZM59.7234 46.5551C59.4091 46.5551 59.1077 46.6799 58.8854 46.9022C58.6632 47.1244 58.5383 47.4258 58.5383 47.7401V47.7528C58.5383 48.4069 59.0692 48.9378 59.7234 48.9378H59.736C60.0503 48.9378 60.3517 48.813 60.574 48.5907C60.7962 48.3685 60.9211 48.0671 60.9211 47.7528V47.7401C60.9211 47.4258 60.7962 47.1244 60.574 46.9022C60.3517 46.6799 60.0503 46.5551 59.736 46.5551H59.7234ZM37.2075 47.7401C37.2075 47.4258 37.3323 47.1244 37.5546 46.9022C37.7768 46.6799 38.0782 46.5551 38.3925 46.5551H38.4052C38.7195 46.5551 39.0209 46.6799 39.2431 46.9022C39.4654 47.1244 39.5902 47.4258 39.5902 47.7401V47.7528C39.5902 48.0671 39.4654 48.3685 39.2431 48.5907C39.0209 48.813 38.7195 48.9378 38.4052 48.9378H38.3925C38.0782 48.9378 37.7768 48.813 37.5546 48.5907C37.3323 48.3685 37.2075 48.0671 37.2075 47.7528V47.7401Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_51_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6306 60.0229C62.6306 60.1803 62.5681 60.3313 62.4568 60.4426C62.3455 60.5539 62.1945 60.6164 62.0371 60.6164C61.8797 60.6164 61.7288 60.5539 61.6175 60.4426C61.5062 60.3313 61.4436 60.1803 61.4436 60.0229C61.4436 59.8655 61.5062 59.7146 61.6175 59.6033C61.7288 59.492 61.8797 59.4294 62.0371 59.4294C62.1945 59.4294 62.3455 59.492 62.4568 59.6033C62.5681 59.7146 62.6306 59.8655 62.6306 60.0229ZM58.4763 62.3968C58.6337 62.3968 58.7846 62.3343 58.8959 62.223C59.0072 62.1117 59.0698 61.9607 59.0698 61.8033C59.0698 61.6459 59.0072 61.495 58.8959 61.3837C58.7846 61.2724 58.6337 61.2099 58.4763 61.2099C58.3189 61.2099 58.1679 61.2724 58.0566 61.3837C57.9453 61.495 57.8828 61.6459 57.8828 61.8033C57.8828 61.9607 57.9453 62.1117 58.0566 62.223C58.1679 62.3343 58.3189 62.3968 58.4763 62.3968ZM59.0698 63.5837C59.0698 63.7411 59.0072 63.8921 58.8959 64.0034C58.7846 64.1147 58.6337 64.1772 58.4763 64.1772C58.3189 64.1772 58.1679 64.1147 58.0566 64.0034C57.9453 63.8921 57.8828 63.7411 57.8828 63.5837C57.8828 63.4263 57.9453 63.2754 58.0566 63.1641C58.1679 63.0528 58.3189 62.9903 58.4763 62.9903C58.6337 62.9903 58.7846 63.0528 58.8959 63.1641C59.0072 63.2754 59.0698 63.4263 59.0698 63.5837ZM60.2567 62.3968C60.4141 62.3968 60.565 62.3343 60.6763 62.223C60.7876 62.1117 60.8502 61.9607 60.8502 61.8033C60.8502 61.6459 60.7876 61.495 60.6763 61.3837C60.565 61.2724 60.4141 61.2099 60.2567 61.2099C60.0993 61.2099 59.9483 61.2724 59.837 61.3837C59.7258 61.495 59.6632 61.6459 59.6632 61.8033C59.6632 61.9607 59.7258 62.1117 59.837 62.223C59.9483 62.3343 60.0993 62.3968 60.2567 62.3968ZM60.8502 63.5837C60.8502 63.7411 60.7876 63.8921 60.6763 64.0034C60.565 64.1147 60.4141 64.1772 60.2567 64.1772C60.0993 64.1772 59.9483 64.1147 59.837 64.0034C59.7258 63.8921 59.6632 63.7411 59.6632 63.5837C59.6632 63.4263 59.7258 63.2754 59.837 63.1641C59.9483 63.0528 60.0993 62.9903 60.2567 62.9903C60.4141 62.9903 60.565 63.0528 60.6763 63.1641C60.7876 63.2754 60.8502 63.4263 60.8502 63.5837ZM62.0371 62.3968C62.1945 62.3968 62.3455 62.3343 62.4568 62.223C62.5681 62.1117 62.6306 61.9607 62.6306 61.8033C62.6306 61.6459 62.5681 61.495 62.4568 61.3837C62.3455 61.2724 62.1945 61.2099 62.0371 61.2099C61.8797 61.2099 61.7288 61.2724 61.6175 61.3837C61.5062 61.495 61.4436 61.6459 61.4436 61.8033C61.4436 61.9607 61.5062 62.1117 61.6175 62.223C61.7288 62.3343 61.8797 62.3968 62.0371 62.3968ZM62.6306 63.5837C62.6306 63.7411 62.5681 63.8921 62.4568 64.0034C62.3455 64.1147 62.1945 64.1772 62.0371 64.1772C61.8797 64.1772 61.7288 64.1147 61.6175 64.0034C61.5062 63.8921 61.4436 63.7411 61.4436 63.5837C61.4436 63.4263 61.5062 63.2754 61.6175 63.1641C61.7288 63.0528 61.8797 62.9903 62.0371 62.9903C62.1945 62.9903 62.3455 63.0528 62.4568 63.1641C62.5681 63.2754 62.6306 63.4263 62.6306 63.5837ZM63.8175 62.3968C63.9749 62.3968 64.1259 62.3343 64.2372 62.223C64.3485 62.1117 64.411 61.9607 64.411 61.8033C64.411 61.6459 64.3485 61.495 64.2372 61.3837C64.1259 61.2724 63.9749 61.2099 63.8175 61.2099C63.6601 61.2099 63.5092 61.2724 63.3979 61.3837C63.2866 61.495 63.224 61.6459 63.224 61.8033C63.224 61.9607 63.2866 62.1117 63.3979 62.223C63.5092 62.3343 63.6601 62.3968 63.8175 62.3968ZM64.411 63.5837C64.411 63.7411 64.3485 63.8921 64.2372 64.0034C64.1259 64.1147 63.9749 64.1772 63.8175 64.1772C63.6601 64.1772 63.5092 64.1147 63.3979 64.0034C63.2866 63.8921 63.224 63.7411 63.224 63.5837C63.224 63.4263 63.2866 63.2754 63.3979 63.1641C63.5092 63.0528 63.6601 62.9903 63.8175 62.9903C63.9749 62.9903 64.1259 63.0528 64.2372 63.1641C64.3485 63.2754 64.411 63.4263 64.411 63.5837ZM65.5979 62.3968C65.7553 62.3968 65.9063 62.3343 66.0176 62.223C66.1289 62.1117 66.1914 61.9607 66.1914 61.8033C66.1914 61.6459 66.1289 61.495 66.0176 61.3837C65.9063 61.2724 65.7553 61.2099 65.5979 61.2099C65.4405 61.2099 65.2896 61.2724 65.1783 61.3837C65.067 61.495 65.0045 61.6459 65.0045 61.8033C65.0045 61.9607 65.067 62.1117 65.1783 62.223C65.2896 62.3343 65.4405 62.3968 65.5979 62.3968ZM64.411 60.0229C64.411 60.1803 64.3485 60.3313 64.2372 60.4426C64.1259 60.5539 63.9749 60.6164 63.8175 60.6164C63.6601 60.6164 63.5092 60.5539 63.3979 60.4426C63.2866 60.3313 63.224 60.1803 63.224 60.0229C63.224 59.8655 63.2866 59.7146 63.3979 59.6033C63.5092 59.492 63.6601 59.4294 63.8175 59.4294C63.9749 59.4294 64.1259 59.492 64.2372 59.6033C64.3485 59.7146 64.411 59.8655 64.411 60.0229ZM65.5979 60.6164C65.7553 60.6164 65.9063 60.5539 66.0176 60.4426C66.1289 60.3313 66.1914 60.1803 66.1914 60.0229C66.1914 59.8655 66.1289 59.7146 66.0176 59.6033C65.9063 59.492 65.7553 59.4294 65.5979 59.4294C65.4405 59.4294 65.2896 59.492 65.1783 59.6033C65.067 59.7146 65.0045 59.8655 65.0045 60.0229C65.0045 60.1803 65.067 60.3313 65.1783 60.4426C65.2896 60.5539 65.4405 60.6164 65.5979 60.6164Z",
    fill: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3085 51.8817L59.0094 51.1808C59.3082 51.4797 59.4761 51.885 59.4761 52.3076V52.4945H64.5977V52.3076C64.5977 51.885 64.7656 51.4797 65.0644 51.1808M58.3085 51.8817L65.0644 51.1808M58.3085 51.8817L59.0094 51.1808C58.7105 50.882 58.3052 50.7141 57.8826 50.7141C57.46 50.7141 57.0547 50.882 56.7558 51.1808L57.4485 51.8735L56.7558 51.1808C56.457 51.4797 56.2891 51.885 56.2891 52.3076V52.5191C55.5441 52.6095 54.8461 52.9466 54.31 53.4827C53.6772 54.1154 53.3218 54.9736 53.3218 55.8684V64.7705C53.3218 65.6653 53.6772 66.5234 54.31 67.1562L54.31 67.1562C54.9427 67.7889 55.8009 68.1443 56.6957 68.1443H67.3781C68.2729 68.1443 69.1311 67.7889 69.7638 67.1562L69.0567 66.4491L69.7638 67.1562C70.3966 66.5234 70.752 65.6653 70.752 64.7705V55.8684C70.752 54.9736 70.3966 54.1154 69.7638 53.4827L69.1039 54.1427L69.7638 53.4827C69.2277 52.9466 68.5297 52.6095 67.7847 52.5191V52.3076C67.7847 51.885 67.6168 51.4797 67.3179 51.1808C67.0191 50.882 66.6138 50.7141 66.1912 50.7141C65.7686 50.7141 65.3633 50.882 65.0644 51.1808M58.3085 51.8817L65.0644 51.1808M67.5103 58.7036C67.5454 58.7386 67.5651 58.7862 67.5651 58.8358V64.7705C67.5651 64.82 67.5454 64.8676 67.5103 64.9027C67.4753 64.9377 67.4277 64.9574 67.3781 64.9574H56.6957C56.6461 64.9574 56.5985 64.9377 56.5635 64.9026C56.5284 64.8676 56.5087 64.82 56.5087 64.7705V58.8358C56.5087 58.7862 56.5284 58.7386 56.5635 58.7036C56.5985 58.6685 56.6461 58.6488 56.6957 58.6488H67.3781C67.4277 58.6488 67.4753 58.6685 67.5103 58.7036Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1917)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1917",
    x1: 29.3237,
    y1: 9.68107,
    x2: 29.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1917",
    x1: 65.3237,
    y1: 9.68107,
    x2: 65.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1917",
    x1: 101.324,
    y1: 9.68107,
    x2: 101.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1917",
    x1: 136.324,
    y1: 9.68107,
    x2: 136.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1917",
    x1: -60.1421,
    y1: 30.4795,
    x2: 195.012,
    y2: 30.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1917",
    x1: -60.1421,
    y1: 89.4795,
    x2: 195.012,
    y2: 89.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1917",
    x1: -60.1421,
    y1: 59.4795,
    x2: 195.012,
    y2: 59.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1917",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1917",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_51_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(31 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_51_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9911,
    height: 18.9911,
    fill: "white",
    transform: "translate(52.5415 49.9338)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact5);
export default __webpack_public_path__ + "static/media/contact5.1b3ecb4ebd87bc9310e626bc1fd6cff7.svg";
export { ForwardRef as ReactComponent };